// 網址參數讀取 — 對應 Unity URLParameter。
// 遊戲 token 與 Demo 模式判定（與後端 BaseGameService 一致）。

function getParam(name: string): string | null {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search).get(name)
}

/** 遊戲 token：`?t=` 優先，其次 `?token=`。對應 Unity GetGameToken()。 */
export function getGameToken(): string | null {
  return getParam('t') ?? getParam('token')
}

/** Demo 模式（略過登入）：`?demo=true` 或帶 `?replay`。對應 Unity SendLogin() 的 isDemo。 */
export function isDemoMode(): boolean {
  return getParam('demo') === 'true' || getParam('replay') !== null
}
